import { z } from "zod";
export const ApplicationAnalyticsSchema = z.object({
    name: z.string(),
    // When the application was created
    createdAt: z.date(),
    // SDK Version that is being used by the application
    sdkUpdateState: z.string(),
    topSDKVersion24h: z.string(),
    topSDKVersion7d: z.string(),
    latestSDKVersion7d: z.string(),
    releasesBehind: z.number(),
    // Onboarding state
    onboardingSDKInstalled: z.boolean(),
    onboradingSDKInstalledAt: z.date().nullable().optional(),
    onboardingPaywallPresented: z.boolean(),
    onboardingPaywallPresentedAt: z.date().nullable().optional(),
    onboardingTransactionCompleted: z.boolean(),
    onboardingTransactionCompletedAt: z.date().nullable().optional(),
    onboardingProductsCreated: z.boolean(),
    onboardingProductsCreatedAt: z.date().nullable().optional(),
    onboardingProductsAddedToPaywall: z.boolean(),
    onboardingProductsAddedToPaywallAt: z.date().nullable().optional(),
    onboardingCompleted: z.boolean(),
    onboardingCompletedAt: z.date().nullable().optional(),
    onboardingProductionTransactionCompleted: z.boolean(),
    onboardingProductionTransactionCompletedAt: z.date().nullable().optional(),
    // Rough usage stats
    transactions1d: z.number(),
    transactions7d: z.number(),
    transactionsPrevious7d: z.number(),
    transactionsPrevious7dDeltaAbsolute: z.number(),
    transactionsPrevious7dDeltaPercentage: z.number(),
    transactions28d: z.number()
});
